import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OAuthService } from "angular-oauth2-oidc";
import { authConfig } from "src/app/shared/auth/models/auth.config";
import { HeaderGovBrComponent } from "../main/header-gov-br/header-gov-br.component";
import { environment } from "src/environments/environment";

@Component({
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: true,
    imports:[CommonModule, HeaderGovBrComponent]
})

export class LoginComponent {
  oauthService = inject(OAuthService);
  periodoEleitoral: boolean = environment.periodoEleitoral;

  constructor() {
    this.configure();
  }

  private configure() {
    this.oauthService.configure(authConfig);
  }

  public loginGovBr() {
    this.login();
  }

  public async login() {
    await this.oauthService.loadDiscoveryDocumentAndTryLogin();
    this.oauthService.initCodeFlow();
  }
}
